import { render, staticRenderFns } from "./talent-development.vue?vue&type=template&id=1479639d&scoped=true&"
import script from "./talent-development.vue?vue&type=script&lang=js&"
export * from "./talent-development.vue?vue&type=script&lang=js&"
import style0 from "./talent-development.vue?vue&type=style&index=0&id=1479639d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479639d",
  null
  
)

export default component.exports